import React from 'react';
import { View } from 'react-native-web';

import './Spacer.module.scss';

/**
 * Meant to be used with flexbox layouyts
 * Takes up space between flex items to separate
 * them as much as possible within a flex container.
 * @returns {*}
 * @constructor
 */
export default function Spacer() {
  return <View styleName="spacer" />;
}
